var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _c(
      "div",
      { staticClass: "card-header p-0", attrs: { id: "headingFeatureInfo" } },
      [
        _c(
          "a",
          {
            staticClass: "btn btn-block text-left p-3",
            attrs: {
              "data-toggle": "collapse",
              role: "button",
              href: "#collapseFeatureInfo",
              "aria-expanded": "false",
              "aria-controls": "collapseFeatureInfo",
            },
          },
          [
            _c("h6", { staticClass: "mb-0" }, [
              _vm._v(_vm._s(_vm.$t(`${_vm.modelTranslateID}.title`))),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "collapse",
        attrs: {
          id: "collapseFeatureInfo",
          "aria-labelledby": "headingFeatureInfo",
          "data-parent": "",
        },
      },
      [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12 col-sm-auto align-self-sm-center mb-3" },
              [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "div",
                    { staticClass: "form-check city-form-check pl-0" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.queryable,
                            expression: "form.queryable",
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "",
                            expression: "''",
                          },
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "checkbox",
                          id: `cb-queryable`,
                          name: `queryable`,
                          disabled: _vm.readonlyForm || !this.hasResources,
                          "false-value": false,
                          "true-value": true,
                          "data-vv-scope": _vm.vScope,
                        },
                        domProps: {
                          checked: Array.isArray(_vm.form.queryable)
                            ? _vm._i(_vm.form.queryable, null) > -1
                            : _vm.form.queryable,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.form.queryable,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.form,
                                    "queryable",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.form,
                                    "queryable",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.form, "queryable", $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label h-auto",
                          attrs: { for: `cb-queryable` },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-column align-items-start",
                            },
                            [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      `${_vm.modelTranslateID}.queryable.status`
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-sm-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialSelect",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: { required: !!_vm.form.queryable },
                          expression: "{required: !!form.queryable}",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        disabled: _vm.disableField,
                        id: "input-queryable-format",
                        name: "queryable-format",
                        label: "name",
                        options: _vm.formats,
                        reduce: (option) => option.code,
                        "data-vv-scope": _vm.vScope,
                        inputClasses: [
                          {
                            "is-invalid": _vm.fnHasError(
                              "queryable-format",
                              _vm.vScope
                            ),
                          },
                        ],
                        error: _vm.fnFirstError("queryable-format", _vm.vScope),
                      },
                      model: {
                        value: _vm.form.format,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "format",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.format",
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.$t(`${_vm.modelTranslateID}.queryable.format`)
                          ) +
                          "\n                        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-sm-4 align-self-sm-center" }, [
              _c(
                "div",
                { staticClass: "form-group mb-0" },
                [
                  _c(
                    "div",
                    { staticClass: "form-check city-form-check pl-0" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.collapsible,
                            expression: "form.collapsible",
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "",
                            expression: "''",
                          },
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "checkbox",
                          id: `cb-queryable-collapsible`,
                          name: `queryable-collapsible`,
                          disabled: _vm.disableField,
                          "false-value": false,
                          "true-value": true,
                          "data-vv-scope": _vm.vScope,
                        },
                        domProps: {
                          checked: Array.isArray(_vm.form.collapsible)
                            ? _vm._i(_vm.form.collapsible, null) > -1
                            : _vm.form.collapsible,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.form.collapsible,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.form,
                                    "collapsible",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.form,
                                    "collapsible",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.form, "collapsible", $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label h-auto",
                          attrs: { for: `cb-queryable-collapsible` },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-column align-items-start",
                            },
                            [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      `${_vm.modelTranslateID}.queryable.collapsible`
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("HelpSpan", {
                    attrs: { helpText: `${_vm.helpTranslateID}.collapsible` },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-sm-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "",
                          expression: "''",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.disableField,
                        id: "input-queryable-styles",
                        name: "queryable-styles",
                        "data-vv-scope": _vm.vScope,
                        inputClasses: [
                          {
                            "is-invalid": _vm.fnHasError(
                              "queryable-styles",
                              _vm.vScope
                            ),
                          },
                        ],
                        error: _vm.fnFirstError("queryable-styles", _vm.vScope),
                        helpText: `${_vm.helpTranslateID}.styles`,
                      },
                      model: {
                        value: _vm.form.styles,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "styles",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.styles",
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.$t(`${_vm.modelTranslateID}.queryable.styles`)
                          ) +
                          "\n                        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.showConfigFormatJson
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c("h6", { staticClass: "font-weight-normal" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(`${_vm.modelTranslateID}.queryable.group`)
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("hr", { staticClass: "mt-2" }),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "div",
                    { staticClass: "row" },
                    _vm._l(_vm.form.typenames ?? [], function (typename, idx) {
                      return _c(
                        "div",
                        { key: `typename-${idx}`, staticClass: "col-sm" },
                        [
                          _c("LayerTypenameForm", {
                            attrs: {
                              idx: idx,
                              vScope: _vm.vScope,
                              parendId: _vm.idSubPanel,
                              readonlyForm: _vm.disableJsonField,
                              baseTranslateID: _vm.baseTranslateID,
                            },
                            on: {
                              onReset: function ($event) {
                                return _vm.onResetProperties(typename)
                              },
                            },
                            model: {
                              value: _vm.form.typenames[idx],
                              callback: function ($$v) {
                                _vm.$set(_vm.form.typenames, idx, $$v)
                              },
                              expression: "form.typenames[idx]",
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }